/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataPageOfGlobalSettings } from '../../models/data-page-of-global-settings';

export interface GlobalMappingSettingsSearch$Params {
  practiceId?: string | null;
  pageNumber?: number;
  pageSize?: number;
  searchText?: string | null;
  SortByColumn?: string | null;
  SortByDirection?: string | null;
}

export function globalMappingSettingsSearch(http: HttpClient, rootUrl: string, params?: GlobalMappingSettingsSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfGlobalSettings>> {
  const rb = new RequestBuilder(rootUrl, globalMappingSettingsSearch.PATH, 'get');
  if (params) {
    rb.query('practiceId', params.practiceId, {});
    rb.query('pageNumber', params.pageNumber, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('searchText', params.searchText, {});
    rb.query('SortByColumn', params.SortByColumn, {});
    rb.query('SortByDirection', params.SortByDirection, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataPageOfGlobalSettings>;
    })
  );
}

globalMappingSettingsSearch.PATH = '/globalsettings/search';
